export default __webpack_public_path__ + "static/events-light-74c07f55aa236e937f4b419e249fc9ec.png";